const settings = {
  development: {
    // *** AU infomation ***/
    // AU_API_URL: "https://abinew.wpengine.com/",
    AU_API_URL: "https://abiinteriordev.wpengine.com",
    // AU_API_URL: "https://shopabiinterio.wpengine.com",
    AWS_EXTERNAL_API_URL: "apidev.abiinteriors.com",

    // *** NZ information ***/
    // NZ_API_URL: "https://abidevops.wpengine.com",
    NZ_API_URL: "https://abinzstage.wpengine.com",

    // *** UK information ***/
    // UK_API_URL: "https://abi22uk.wpengine.com",
    UK_API_URL: "https://ukstg.wpengine.com/"
  },
  production: {
    // *** AU information ***/
    AU_API_URL: "https://www.abiinteriors.com.au",
    AWS_EXTERNAL_API_URL: "api.abiinteriors.com",

    // *** NZ information ***/
    NZ_API_URL: "https://www.abiinteriors.co.nz",

    // *** UK information ***/
    UK_API_URL: "https://www.abiinteriors.co.uk"
  }
};

const getCurrentSettings = () => {
  if (process.env.NODE_ENV === "production") {
    return settings.production;
  }
  return settings.development;
};

export default getCurrentSettings();
